import { DatePipe } from '@angular/common';
import {
	EnvironmentProviders,
	importProvidersFrom,
	makeEnvironmentProviders
} from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

// NGX Bootstrap modules
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { AlertModule } from 'ngx-bootstrap/alert';
import { ButtonsModule } from 'ngx-bootstrap/buttons';
import { CarouselModule } from 'ngx-bootstrap/carousel';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { BsModalRef, ModalModule } from 'ngx-bootstrap/modal';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { ProgressbarModule } from 'ngx-bootstrap/progressbar';
import { RatingModule } from 'ngx-bootstrap/rating';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';

// Other modules
import { YouTubePlayerModule } from '@angular/youtube-player';
import { IonicModule } from '@ionic/angular';
import { NgxIcasLibModule } from '@lyra-core/ngx-icas-lib';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { IMaskModule } from 'angular-imask';
import { FileUploadModule } from 'ng2-file-upload';
import { DndModule } from 'ngx-drag-drop';
import { SelectDropDownModule } from 'ngx-select-dropdown';
import { NgxSelectModule } from 'ngx-select-ex';
import { ToastrModule } from 'ngx-toastr';

// Services and pipes
import { I18nArrayValuePipe } from './pipes/i18n-array-value/i18n-array-value.pipe';
import { RemoveHtmlTagsPipe } from './pipes/remove-html-tags/remove-html-tags.pipe';
import { RolesPipe } from './pipes/roles.pipe';
import { StackOrderPipe } from './pipes/stack-order/stack-order.pipe';

/**
 * Provides all shared application services and module configurations
 * This replaces the SharedModule.forRoot() for standalone applications
 */
export function provideShared(): EnvironmentProviders {
	return makeEnvironmentProviders([
		// Import providers from modules that need forRoot()
		importProvidersFrom(
			// Core Angular modules
			FormsModule,
			ReactiveFormsModule,
			RouterModule,

			// NGX Bootstrap modules
			AccordionModule.forRoot(),
			AlertModule.forRoot(),
			ButtonsModule.forRoot(),
			CarouselModule.forRoot(),
			CollapseModule.forRoot(),
			BsDatepickerModule.forRoot(),
			BsDropdownModule.forRoot(),
			ModalModule.forRoot(),
			PaginationModule.forRoot(),
			ProgressbarModule.forRoot(),
			RatingModule.forRoot(),
			TabsModule.forRoot(),
			TimepickerModule.forRoot(),
			TooltipModule.forRoot(),
			PopoverModule.forRoot(),
			TypeaheadModule.forRoot(),

			// Other modules
			ToastrModule.forRoot(),
			NgxDatatableModule,
			SelectDropDownModule,
			NgxSelectModule,
			IMaskModule,
			YouTubePlayerModule,
			DndModule,
			FileUploadModule,
			NgxIcasLibModule,
			IonicModule
		),

		// Shared services (services with providedIn: 'root' don't need to be listed here)
		// ColorsService, // Now provided in root

		// Shared pipes (that need to be injectable)
		I18nArrayValuePipe,
		RolesPipe,
		StackOrderPipe,
		DatePipe,
		RemoveHtmlTagsPipe,

		// Modal reference
		BsModalRef

		// Loading bar configuration moved to core providers
	]);
}
